import moneyReducer from "./moneyReducer";

export default {
  money: moneyReducer
};